import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import type { EmptyScreensBaseArgs } from 'webapp/components/empty-screens/base';
import EmptyScreensBaseComponent from 'webapp/components/empty-screens/base';

export default class EmptyScreensReportAccountTemplatesComponent extends EmptyScreensBaseComponent<EmptyScreensBaseArgs> {
	@service('account') declare accountService: Service.Account;

	trackingOrigin = 'report_account_templates';

	override requireAllBillingFeatures = true;

	constructor(owner: Owner, args: EmptyScreensBaseArgs) {
		super(owner, args);

		this.titleText = 'Account templates';
		this.descText =
			'Create reusable account templates with the dashboards, side by side slides, and data stories you need to set up accounts faster and keep reporting consistent.';
		this.topImageLightUrl = '/images/placeholders/report-account-templates.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/report-account-templates.svg';

		this.trialFeatures = [BillingFeature.REPORTS_BASIC, BillingFeature.ACCOUNT_TEMPLATES];
		this.readMoreUrl = 'https://help.databox.com/create-a-template';

		this.imageLightUrl = '/images/placeholders/placeholder-report-account-templates.svg';
		this.imageDarkUrl = '/images/placeholders/dark/placeholder-report-account-templates.svg';

		this.mainActions = [
			{
				action: this.create,
				icon: 'Plus',
				text: 'New template',
				isForCreating: true,
			},
		];

		this.arrowText = 'Click here to create your first account template';
	}
}
